<template>
  <div class="tags">
    <Tags/>
  </div>
</template>

<script>
// @ is an alias to /src
import Tags from '@/components/Tags.vue'

export default {
  name: 'TagsPage',
  components: {
    Tags
  }
}
</script>
